import { type ReactNode, useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

// Long goal titles (older plans kept the user's whole sentence) clamp to three
// lines with a "more" toggle. The child gets the clamp class so the clamp sits
// on the element that holds the text.
export function ClampText({
  children,
  off = false,
  className,
}: {
  children: (clamp: string) => ReactNode
  off?: boolean
  className?: string
}) {
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState(false)
  const [overflows, setOverflows] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current?.querySelector('.line-clamp-3')
    if (!el || open || off) return
    const check = () => setOverflows(el.scrollHeight > el.clientHeight + 1)
    check()
    const ro = new ResizeObserver(check)
    ro.observe(el)
    return () => ro.disconnect()
  })

  return (
    <div className={className}>
      <div ref={ref}>{children(open || off ? '' : 'line-clamp-3')}</div>
      {!off && (overflows || open) && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            setOpen((o) => !o)
          }}
          className="mt-1 cursor-pointer text-xs font-semibold text-muted-foreground hover:text-foreground"
        >
          {open ? t('goals.titleLess') : t('goals.titleMore')}
        </button>
      )}
    </div>
  )
}
